export default __webpack_public_path__ + "static/media/p9.9cdaa1ba.jpeg";